<template>
  <modal class="freeShippingModel" :isShow="isShow" @keyup.esc="hide">
    <div class="header">免单信息确认</div>
    <div class="modal-body">
        <div class="left-box">
            <div class="money-info" v-if="orderInfo">
                <div class="lable-txt" >
                    待支付金额：<b class="noney red" v-if="orderInfo">{{Number(orderInfo?.UnPaid_Money).toFixed(2)}}</b>
                </div>
            </div>
            <div class="notes" v-show="maxPayMoney">
                注:本单最大可用免单金额{{maxPayMoney}}元
            </div>
            <div class="tr-box payamount">
                <div class="label-txt">付款金额:</div>
                <div class="from-input">
                    <input-pattern ref="money" data-model='money' v-model="money" pattern="money" :max="maxPayMoney" @focus="(e)=>e.target.select()"   />
                </div>
            </div>
            <div class="title-box">招待信息</div>
            <div class="tr-box">
                <div class="label-txt">招待客户:</div>
                <div class="from-input">
                    <input type="text" ref="customer" v-model="customerName"/>
                </div>
            </div>
            <div class="tr-box">
                <div class="label-txt">免单确认人:</div>
                <div class="from-input">
                    <input type="text" ref="poerson" v-model="freeConfirmPerson"/>
                </div>
            </div>
            <div class="tr-box">
                <div class="label-txt">备注:</div>
                <div class="from-input">
                    <input type="text" v-model="remark"/>
                </div>
            </div>
        </div>
        <div class="right-box">
            <div class="keyboard">
                <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                        data-value="9">9</span></div>
                <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                        data-value="6">6</span></div>
                <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                        data-value="3">3</span></div>
                <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                        data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
            </div>
        </div>
    </div>
    <div class="footer-box">
        <button class="btn btn-cancel" @click="hide()">取消</button>
        <button class="btn btn-confirm" @click="confirm()" v-throttle>确认</button>
    </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

/**会员支付 */
export default {
    name:"scanCodePayModel",
    props:{
        //是否显示
        isShow:{
            type:Boolean,
            default:false
        },
        //订单数据
        orderInfo:{
            type:Object,
            default:null
        },
        //支付方式数据
        payTypeSSPay:{},
        //是否存在记录的微生活信息
        wlivePayExist:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            userInfo:null,
            money:"",
            //招待客户
            customerName:"",
            //免单确认人
            freeConfirmPerson:"",
            //备注
            remark:""
        }
    },
    mounted(){
        this.userInfo=this.$auth.getUserInfo(); //获取用户id
        this.$nextTick(()=> {
            initKeyBoard.call(this,this.$el,this.$refs.money?.$el);
            this.init();
        })
    },
    computed:{
        /**支付金额最大可输入多少 */
        maxPayMoney(){
            if(this.userInfo){
                let freeMoney=this.userInfo?.LimitedFreeMoneyOfEachBill||0;
                if(this.userInfo.LimitedFreeMoneyOfEachBillType==1){//金额 
                    return freeMoney;
                }else if(this.userInfo.LimitedFreeMoneyOfEachBillType==2){//折前消费金额%
                    return Number(this.orderInfo.Eat_SaleMoney).compute((freeMoney/100),'*');
                }else if(this.userInfo.LimitedFreeMoneyOfEachBillType==3){//折后消费金额%
                    return Number(this.orderInfo.Eat_CheckMoney).compute((freeMoney/100),'*');
                }
            }
            return null;
        }
    },
    watch: {
        //用于观察数据变动。对应一个对象,键是观察表达式,值是对应回调。子组件中 需要结合watch监听
        isShow() { 
            if(this.isShow){
                this.init();
            }
        }
    },
    methods:{
        init(){
            this.money='';
            if(this.maxPayMoney>0){
                if(this.maxPayMoney>this.orderInfo?.UnPaid_Money){
                    this.money=this.orderInfo?.UnPaid_Money;
                }else{
                    this.money=this.maxPayMoney;
                }
            }
            setTimeout(() => {
                this.$refs.money.focus();
            },100);
        },
        hide(){
            this.$emit("close");
        },
        /**确定和回车事件 */
        confirm(){
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let FactMoney=[];
            let giveFreeExtendInfo={
                CustomerName:this.customerName.trim(),//招待客户
                FreeConfirmPerson:this.freeConfirmPerson.trim(),//免单确认人
                Remark:this.remark.trim(),//备注
            }
            if(!giveFreeExtendInfo.CustomerName && !giveFreeExtendInfo.FreeConfirmPerson && !giveFreeExtendInfo.Remark){
                giveFreeExtendInfo=null;
            }
            if(Number(this.money)>0){
                FactMoney.push({
                    Payment_ID:this.payTypeSSPay.PAY_ID, //支付方式ID
                    Payment_Code:this.payTypeSSPay.PAY_CODE,  //支付方式编号
                    Payment_Name:this.payTypeSSPay.PAY_NAME,  //支付方式名称
                    Payment_Type:this.payTypeSSPay.INTERFACE_TYPE,  //支付方式类型
                    Payment_Money:Number(this.money), //支付方式金额
                    Payment_FactMoney:Number(this.money),  //支付实收金额
                    Payment_Remark:"",
                    Qr_Code:"", //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                    GiveFreeExtendInfo:giveFreeExtendInfo,//免单信息
                });
            }else{
                this.$message.warning("付款金额必须大于0!");
                this.$refs.money.focus();
                return;
            }
           
             //当实付金额大于剩余结账金额时  +Number(this.orderInfo.Mantissa_Money)
            if(Number(Number(this.money).toFixed(2))>Number(Number(this.orderInfo.UnPaid_Money).toFixed(2))){
                FactMoney.push({
                    Payment_ID:this.payTypeSSPay.PAY_ID, //支付方式ID
                    Payment_Code:this.payTypeSSPay.PAY_CODE,  //支付方式编号
                    Payment_Name:this.payTypeSSPay.PAY_NAME,  //支付方式名称
                    Payment_Type:this.payTypeSSPay.INTERFACE_TYPE,  //支付方式类型
                    Payment_Money:Number(this.orderInfo.UnPaid_Money)-Number(this.money), //支付方式金额
                    Payment_FactMoney:Number(this.orderInfo.UnPaid_Money)-Number(this.money),  //支付实收金额
                    Payment_Remark:this.RemarkTitle,
                    Qr_Code:"", //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                });
            }
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            //支付预览
            let param={
                User_ID:userInfo?.User_ID,  //用户id
                Eat_AutoID:this.orderInfo.Eat_AutoID, //结账单ID
                UnionOrders:this.unionEatAutoID,//联台订单集合
                Timestamps:this.orderInfo.Timestamps.toString(),//账单时间戳
                Operator_Name:userInfo?.Login_Name, //操作员
                Eat_DeskName:this.orderInfo.Eat_DeskName,//桌牌号
                Service_Charge:this.orderInfo.Service_Money,//服务费
                MantissaAdjustment_Money:Number(Number(this.orderInfo.Mantissa_Money).toFixed(2)), //尾数调整金额
                Member:null,//会员信息
                Payments:FactMoney,//支付方式
            }
            this.$emit("publicPayPreview",param,'freeShippingShow')
        },
    }
}
</script>

<style lang="sass">
@import "./freeShippingModel.scss";
</style>